orders-table
  section.app-table
    header.app-table-header
      .row
        .col-12.col-md-4
          b.client_name
            i.feather.icon-target
            | { opts.locale.header.client_name.label }
          br
          span.product_name
            i.feather.icon-box
            | { opts.locale.header.product_name.label}
            br(if="{ opts.product_id }")
            span.text-muted { opts.product_id }
        .col-12.col-md-3
          span.required_num
            | { opts.locale.header.required_num.label}
          span.separater.text-muted
            | &nbsp;*&nbsp;
          br
          span.user_name
            | { opts.locale.header.user_name.label }
        .col-12.col-md-4
          span.deadline
            | { opts.locale.header.deadline.label }
        .col-12.col-md-1.text-right
    .app-table-body
      .row(each="{ opts.items }")
        .col-12.col-md-4
          a.job_no(href="{ show_path }")
            h5
              span(if="{is.informations_fixed}")
                | { parent.opts.locale.job_no_label } { job_no } &nbsp;
              span.text-danger(if="{!is.informations_fixed}" data-toggle="tooltip" data-placement="top" data-original-title="確認中の情報あり")
                | { parent.opts.locale.job_no_label } { job_no } &nbsp;
              span.badge.badge-info.order_type(if="{is.casting_biz}") { parent.opts.locale.casting_biz }
              span.badge.badge-info.order_type(if="{is.ct_biz}") { parent.opts.locale.ct_biz }
              span.badge.badge-primary.order_type(if="{is.new_order}") { parent.opts.locale.new_order }
              span.badge.badge-success.order_type(if="{is.repeater}")   { parent.opts.locale.repeater }
              span.badge.badge-warning.order_type(if="{is.changing}")   { parent.opts.locale.changing }
              span.badge.badge-inverse-default.status(if="{is.information}") { parent.opts.locale.information}
              span.badge.badge-default.status(if="{is.unofficial}") { parent.opts.locale.unofficial}
              span.badge.badge-warning.status(if="{is.received}") { parent.opts.locale.received}
              span.badge.badge-inverse-primary.status(if="{is.pending}") { parent.opts.locale.pending}
              span.badge.badge-inverse-danger.secondary.status(if="{is.failed}") { parent.opts.locale.failed}
              span.badge.badge-success.status(if="{is.done}") { parent.opts.locale.done}
              span.badge.badge-danger.approval(if="{is.not_approved}") { parent.opts.locale.not_approved }
          b.client_name
            i.feather.icon-target
            | { client_name }
            span(if="{client_person_name}") { client_person_name }
          br
          span.product_name
            i.feather.icon-box
            | { product_name }
            span(if="{ product_id }") { product_id }
        .col-12.col-md-3
          span.required_num
            span.badge.badge-danger(if="{ required_num <= 0}") !
            | { required_num }
          span.separater.text-muted
            | &nbsp;*&nbsp;
          br
          span.user_name
            i.feather.icon-user
            | { user_name }
        .col-12.col-md-4
          span.deadline
            span.badge.badge-danger(if="{ !deadline }") !
            i.feather.icon-calendar
            | { deadline }
        .col-12.col-md-1.text-right
          a.btn.btn-primary.mb-1.editable(href="{ copy_path }")
            i.feather.icon-copy
          a.btn.btn-primary.ml-1.mb-1.editable(href="{ edit_path }")
            i.feather.icon-edit
  shared-paginate(tag-scope="{this.tagScope}.paginate")
  script(type="typescript").
    this.mixin('table');
  style(scoped).
    :scope {
      display: block;
    }
    .badge.order_type{
      display: inline-block;
      margin-right: 1px;
    }
